import { Box, Container, Chip, Typography } from "@mui/material";


export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = "center",
}) {
  return (
    <Box
      sx={{
        textAlign: align,
        maxWidth: align === "center" ? 720 : "none",
        mx: align === "center" ? "auto" : 0,
        mb: { xs: 5, md: 7 },
      }}
    >
      {eyebrow && (
        <Chip
          label={eyebrow}
          size="small"
          sx={{
            mb: 2,
            fontWeight: 700,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            fontSize: 11,
            color: "#60a5fa",
            bgcolor: "rgba(96,165,250,0.12)",
          }}
        />
      )}

      <Typography
        sx={{
          fontSize: { xs: "1.9rem", md: "2.6rem" },
          fontWeight: 800,
          color: "#f8fafc",
          mb: 2,
          lineHeight: 1.2,
        }}
      >
        {title}
      </Typography>

      {subtitle && (
        <Typography
          sx={{
            color: "rgba(248,250,252,.72)",
            fontSize: { xs: "1rem", md: "1.1rem" },
            lineHeight: 1.6,
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}


export function Section({ id, children, alt = false, sx = {} }) {
  return (
    <Box
      id={id}
      component="section"
      sx={{
        py: { xs: 8, md: 12 },
        backgroundColor: alt
          ? (theme) =>
              theme.palette.mode === "dark"
                ? "rgba(255,255,255,0.015)"
                : "rgba(14,19,32,0.018)"
          : "transparent",
        scrollMarginTop: 80,
        ...sx,
      }}
    >
      <Container maxWidth="lg">{children}</Container>
    </Box>
  );
}